import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, useMapEvents, Polyline } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

function circleWithText2(latLng, txt, radius, borderWidth, circleClass) {
  var size = radius * 2;
  var style =
    'style="width: ' +
    size +
    'px; height: ' +
    size +
    'px; border-width: ' +
    borderWidth +
    'px;"';
  var iconSize = size + borderWidth * 2;
  var icon = L.divIcon({
    html:
      '<span class="' +
      'circle ' +
      circleClass +
      '" ' +
      style +
      '>' +
      txt +
      '</span>',
    className: '',
    iconSize: [iconSize, iconSize],
  });
  var marker = L.marker(latLng, {
    icon: icon,
  });
  return marker;
}

export default function TrackMapMulti({
  my_data,
  track_details,
  userProfiles,
}) {
  const markerRefs = useRef({});

  useEffect(() => {
    // Clean up markerRefs when my_data changes (e.g., when a new device is added or removed)
    Object.keys(markerRefs.current).forEach((devicename) => {
      if (!my_data[devicename]) {
        // Remove markers that are no longer in my_data
        markerRefs.current[devicename]?.remove();
        delete markerRefs.current[devicename];
      }
    });
  }, [my_data]);

  function LocationMarker({ devicename, car_data }) {
    const map = useMapEvents({
      click(e) {
        console.log({ lat: e.latlng.lat, lng: e.latlng.lng });
      },
    });
    const firstInitial = userProfiles
      .find((o) => o.htrDevice === devicename)
      ?.name.charAt(0);
    const metric = car_data.slice(-1)[0].metrics;
    const latitude = metric.LATITUDE[2] || null;
    const longitude = metric.LONGITUDE[2] || null;

    useEffect(() => {
      if (latitude && longitude) {
        // console.log(latitude, longitude);
        const myCoords = { lat: latitude, lng: longitude };
        if (!markerRefs.current[devicename]) {
          // Create a new marker if it doesn't exist
          // const marker = L.marker(myCoords, { icon: icon }).addTo(map);
          // const marker = L.circleMarker(myCoords, { icon: icon }).addTo(map);
          // marker.setStyle({ radius: 10, fillColor: 'green', fillOpacity: 1 });
          const marker = circleWithText2(
            myCoords,
            firstInitial,
            12,
            3,
            'circle1'
          ).addTo(map);

          markerRefs.current[devicename] = marker;
        } else {
          // Update the position of the existing marker
          markerRefs.current[devicename].setLatLng(myCoords);
        }
      }
    }, [devicename, latitude, longitude, map, firstInitial]);

    return null; // No need to render anything for the markers
  }

  return (
    <div style={{ height: '400px' }}>
      <MapContainer
        bounds={track_details?.gps_bounds}
        fitBounds={track_details?.gps_bounds}
        maxBoundsViscosity={1.0}
        zoom={13}
        style={{ height: '100%' }}
        // zoomControl={false}
        // scrollWheelZoom={false}
        // doubleClickZoom={false}
        // touchZoom={false}
        // boxZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {track_details && (
          <Polyline
            positions={track_details?.startLineFormatted}
            color={'red'}
          ></Polyline>
        )}
        {my_data &&
          Object.entries(my_data).map(([deviceName, carData]) => (
            <LocationMarker
              key={deviceName}
              devicename={deviceName}
              car_data={carData}
            />
          ))}
      </MapContainer>
    </div>
  );
}
